import { KUORI_WORDMARK } from "@expho/design-system/logo";

interface LogoProps {
  readonly height?: number;
}

export function KuoriLogo({ height = 20 }: LogoProps) {
  return (
    <svg
      width={Math.round((KUORI_WORDMARK.width / KUORI_WORDMARK.height) * height)}
      height={height}
      viewBox={`0 0 ${KUORI_WORDMARK.width} ${KUORI_WORDMARK.height}`}
      role="img"
      aria-label="Kuori"
    >
      <path fill="currentColor" fill-rule="evenodd" d={KUORI_WORDMARK.path} />
    </svg>
  );
}
